import './polyfills'
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ErrorBoundary } from '@sentry/react';
import './instrument';
import App from './App';

// Component hiển thị khi có lỗi
const FallbackComponent = ({ error, componentStack, resetError }) => {
  return (
    <div
      style={{
        padding: '20px',
        textAlign: 'center',
        marginTop: '50px',
      }}
    >
      <h2>Đã xảy ra lỗi</h2>
      <p>Vui lòng tải lại trang hoặc thử lại sau</p>
      <div
        style={{
          marginTop: 20,
          background: '#f6f6f6',
          padding: 15,
          borderRadius: 6,
          textAlign: 'left',
          whiteSpace: 'pre-wrap',
          maxHeight: 300,
          overflow: 'auto',
          border: '1px solid #ddd',
        }}
      >
        <strong>Message:</strong>
        <div style={{ color: '#d9534f' }}>{error?.message}</div>

        <br />

        <strong>Stack Trace:</strong>
        <div>{error?.stack}</div>

        <br />

        <strong>React Component Stack:</strong>
        <div>{componentStack}</div>
      </div>
      <button
        onClick={() => window.location.reload()}
        style={{
          padding: '10px 15px',
          background: '#007bff',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer',
          marginTop: '15px',
        }}
      >
        Tải lại trang
      </button>
    </div>
  );
};

// React 18: dùng createRoot thay cho ReactDOM.render (API cũ đã deprecated).
// Không bọc StrictMode để tránh double-invoke effect gây lạ với code/lib cũ (MUI v4).
const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <ErrorBoundary fallback={FallbackComponent}>
      <App />
    </ErrorBoundary>
  </BrowserRouter>
);
